import { NgModule } from "@angular/core";
import { COMPOSITION_BUFFER_MODE, FormsModule } from "@angular/forms";
import { HttpModule, JsonpModule } from "@angular/http";
import { BrowserModule } from "@angular/platform-browser";
import { RouterModule } from "@angular/router";
/** directive */
import { ContentOutlinkDirective } from "./directive/content-outlink.directive";
import { FocusDirective } from "./directive/focus.directive";
import { OutlinkDirective } from "./directive/outlink.directive";
/** pipe */
import { MinuteToHourPipe } from "./pipe/minuteToHour.pipe";
import { HHMMPipe, MydatePipe } from "./pipe/mydate.pipe";
import { NewlinePipe } from "./pipe/newline.pipe";
import { NewlineOnlyWebPipe } from "./pipe/newlineOnlyWeb.pipe";
import { SpaceTextPipe } from "./pipe/space-text.pipe";

/** bootstrap */
import { CollapseModule } from "ngx-bootstrap/collapse";
import { DatepickerModule } from "ngx-bootstrap/datepicker";
import { ModalModule } from "ngx-bootstrap/modal";
import { PaginationModule } from "ngx-bootstrap/pagination";
import { PopoverModule } from "ngx-bootstrap/popover";
import { TabsModule } from "ngx-bootstrap/tabs";
/** service */
import { CommonService } from "./service/common/common.service";
import { HttpService } from "./service/http/http.service";
/** route */
import { routes } from "./app.route";
/** shared */
import { BreadCrumbComponent } from "./shared/bread-crumb/bread-crumb.component";
import { DateSelectorComponent } from "./shared/date-selector/date-selector.component";
import { FileUploadComponent } from "./shared/file-upload/file-upload.component";
import { RedirectComponent } from "./shared/redirect/redirect.component";
import { SelectorComponent } from "./shared/selector/selector.component";
/** home, login */
import { FindPasswordComponent } from "./find-password/find-password.component";
import { FooterComponent } from "./footer/footer.component";
import { HeaderComponent } from "./header/header.component";
import { HomeComponent } from "./home/home.component";
import { SliderComponent } from "./home/slider/slider.component";
import { TopBannerComponent } from "./home/top-banner/top-banner.component";
import { LoginComponent } from "./login/login.component";
/** heyground > about, location, partners */
import { AboutComponent } from "./heyground/about/about.component";
import { HeygroundComponent } from "./heyground/heyground.component";
import { LocationComponent } from "./heyground/location/location.component";
import { PartnerLinkComponent } from "./heyground/partners/partner-link-item/partner-link-item.component";
import { PartnersComponent } from "./heyground/partners/partners.component";
/** member > mypage */
import { HeaderMemberComponent } from "./header-member/header-member.component";
import { MemberComponent } from "./member/member.component";
import { MypageComponent } from "./member/mypage/mypage.component";
import { AuthService } from "./service/auth/auth.service";

import { MyinfoEditComponent } from "./member/myinfo-edit/myinfo-edit.component";
import { MyinfoComponent } from "./member/myinfo/myinfo.component";
import { SocialComponent } from "./member/shared/social/social.component";

import { AgmCoreModule } from "angular2-google-maps/core";
import { InstagramComponent } from "./home/instagram/instagram.component";
import { MessageModalComponent } from "./member/shared/message-modal/message-modal.component";
import { Page404Component } from "./page-404/page-404.component";
import { Page500Component } from "./page-500/page-500.component";
import { Page502Component } from "./page-502/page-502.component";
import { FilenamePipe } from "./pipe/filename.pipe";
import { SafeHtmlPipe } from "./pipe/safeHtml.pipe";
import { SafeStylePipe } from "./pipe/safeStyle.pipe";
import { PrivacyComponent } from "./privacy/privacy.component";
import { ResetPasswordComponent } from "./reset-password/reset-password.component";
import { MyinfoCanDeactivate } from "./service/member/myinfo-can-deactivate.service";
import { TermsComponent } from "./terms/terms.component";

import { NewsletterComponent } from "./home/newsletter/newsletter.component";
import { ProfileModalComponent } from "./member/shared/profile-modal/profile-modal.component";
import { RoleTextPipe } from "./pipe/role-text.pipe";

import { GtmService } from "./service/gtm/gtm.service";
import { MemberService } from "./service/member/member.service";
import { ShareService } from "./service/share/share.service";

/* Space by location */
import { SeongsuComponent } from "./seongsu/seongsu.component";
import { SeongsuSpaceComponent } from "./seongsu/space/space.component";
import { SeoulsoopComponent } from "./seoulsoop/seoulsoop.component";
import { SeoulsoopSpaceComponent } from "./seoulsoop/space/space.component";
import { FaqComponent } from "./space/faq/faq.component";
import { FloorItemComponent } from "./space/floor-item/floor-item.component";
import { SpaceMembersComponent } from "./space/members/members.component";
import { PlanComponent } from "./space/plan/plan.component";

import { SpaceMemberDetailComponent } from "./space/member-detail/member-detail.component";

import { TourDetailComponent } from "./space/tour-detail/tour-detail.component";
import { TourListComponent } from "./space/tour-list/tour-list.component";
import { TourLookupComponent } from "./space/tour-lookup/tour-lookup.component";
import { TourComponent } from "./space/tour/tour.component";

import { ApplyComponent } from "./apply/apply.component";

/* Member */
import { QuillEditorModule } from "ngx-quill-editor";
import { CommentReisterComponent } from "./member/shared/comment-register/comment-reg.component";
import { CommentComponent } from "./member/shared/comment/comment.component";

import { MemberHomeComponent } from "./member/home/home.component";

import { HeyBoardComponent } from "./member/hey-board/hey-board.component";
import { HeyDetailComponent } from "./member/hey-board/hey-detail/hey-detail.component";
import { HeyItemComponent } from "./member/hey-board/hey-item/hey-item.component";
import { HeyListComponent } from "./member/hey-board/hey-list/hey-list.component";

import { CommunityBoardComponent } from "./member/community-board/community-board.component";
import { CommunityDetailComponent } from "./member/community-board/community-detail/community-detail.component";
import { CommunityItemComponent } from "./member/community-board/community-item/community-item.component";
import { CommunityListComponent } from "./member/community-board/community-list/community-list.component";

import { ReservationListComponent } from "./member/reservation/list/list.component";
import { ReservationComponent } from "./member/reservation/reservation.component";
import { ReservationRoomsComponent } from "./member/reservation/rooms/rooms.component";
import { ReservationSpacesComponent } from "./member/reservation/spaces/spaces.component";

import { RentalItemComponent } from "./member/rental/item/item.component";
import { RentalComponent } from "./member/rental/rental.component";

import { MemberBoardComponent } from "./member/member-board/member-board.component";
import { MemberDetailComponent } from "./member/member-board/member-detail/member-detail.component";

import { HelpBoardComponent } from "./member/help-board/help-board.component";
import { HelpDetailComponent } from "./member/help-board/help-detail/help-detail.component";
import { HelpListComponent } from "./member/help-board/help-list/help-list.component";

import { BillBoardComponent } from "./member/bill-board/bill-board.component";
import { CreditBoardComponent } from "./member/credit-board/credit-board.component";
import { PrintingBoardComponent } from "./member/printing-board/printing-board.component";

import { GuideDetailComponent } from "./member/guide/guide-detail/guide-detail.component";
import { GuideComponent } from "./member/guide/guide.component";

import { BenefitBoardComponent } from "./member/benefit-board/benefit-board.component";
import { BenefitDetailComponent } from "./member/benefit-board/benefit-detail/benefit-detail.component";

import { GuestComponent } from "./member/guest/guest.component";
import { ManagementComponent } from "./member/management/management.component";

import { ApplicationGuard } from "./application.guard";

/* Home */
import { HomeMemberComponent } from "./home/home-member/home-member.component";
import { HomeSectionComponent } from "./home/home-section/home-section.component";

// 정리
import { AppComponent } from "./app.component";
import * as Modal from "./modal";
import { SignUpComponent } from "./signup/signup.component";

@NgModule({
  declarations: [
    // Layout
    AppComponent,

    // Modal
    Modal.PrivacyComponent,
    Modal.ThirdPartyComponent,
    Modal.LeaveComponent,

    // Page
    SignUpComponent,

    // -----

    // Page
    HomeComponent,
    SliderComponent,
    TopBannerComponent,
    HeaderComponent,
    FooterComponent,
    RedirectComponent,
    BreadCrumbComponent,
    HeygroundComponent,
    AboutComponent,
    LocationComponent,
    PartnersComponent,
    PartnerLinkComponent,
    ApplyComponent,

    // pipe
    MydatePipe,
    HHMMPipe,
    NewlinePipe,
    SpaceTextPipe,
    MinuteToHourPipe,
    NewlineOnlyWebPipe,

    LoginComponent,
    DateSelectorComponent,
    FindPasswordComponent,
    HeaderMemberComponent,
    MypageComponent,
    MemberComponent,
    FileUploadComponent,

    CommentComponent,
    SocialComponent,
    MyinfoComponent,
    SelectorComponent,
    FocusDirective,
    MyinfoEditComponent,

    InstagramComponent,
    MessageModalComponent,
    FilenamePipe,
    ManagementComponent,
    ResetPasswordComponent,
    TermsComponent,
    PrivacyComponent,
    Page404Component,
    Page500Component,
    Page502Component,
    OutlinkDirective,
    ContentOutlinkDirective,
    SafeHtmlPipe,
    SafeStylePipe,

    RoleTextPipe,
    NewsletterComponent,
    ProfileModalComponent,

    /* Home */
    HomeMemberComponent,
    HomeSectionComponent,

    /* Space by location */
    SeongsuComponent,
    SeongsuSpaceComponent,
    SeoulsoopComponent,
    SeoulsoopSpaceComponent,
    FloorItemComponent,

    TourComponent,
    TourLookupComponent,
    TourListComponent,
    TourDetailComponent,

    SpaceMembersComponent,
    SpaceMemberDetailComponent,
    PlanComponent,
    FaqComponent,

    /* Member */
    CommentReisterComponent,

    MemberHomeComponent,

    HeyBoardComponent,
    HeyListComponent,
    HeyItemComponent,
    HeyDetailComponent,
    CommunityBoardComponent,
    CommunityListComponent,
    CommunityItemComponent,
    CommunityDetailComponent,
    ReservationComponent,
    ReservationRoomsComponent,
    ReservationSpacesComponent,
    ReservationListComponent,
    RentalComponent,
    RentalItemComponent,
    MemberBoardComponent,
    MemberDetailComponent,
    HelpBoardComponent,
    HelpListComponent,
    HelpDetailComponent,

    CreditBoardComponent,
    BillBoardComponent,
    PrintingBoardComponent,

    GuideComponent,
    GuideDetailComponent,
    BenefitBoardComponent,
    BenefitDetailComponent,
    GuestComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    JsonpModule,
    TabsModule.forRoot(),
    PaginationModule.forRoot(),
    DatepickerModule.forRoot(),
    CollapseModule.forRoot(),
    ModalModule.forRoot(),
    PopoverModule.forRoot(),
    RouterModule.forRoot(routes, { useHash: true }),
    AgmCoreModule.forRoot({
      apiKey: "AIzaSyDSNLHoN3khjTKY-f3VHG0Gr5CoQVuQK-8",
    }),
    QuillEditorModule,
  ],
  providers: [
    ShareService,
    ApplicationGuard,
    AuthService,
    HttpService,
    CommonService,
    MyinfoCanDeactivate,
    GtmService,
    MemberService,
    { provide: COMPOSITION_BUFFER_MODE, useValue: false },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts